export default __webpack_public_path__ + "static/media/ex-link.6d7c1817.svg";